<script setup>
  import NewsCardRelated from '~/components/parts/news/NewsCardRelated.vue';

  // --

  const { items } = defineProps({ items: Array, black: Boolean, reducedBottomPadding: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <SliderSection
    :items="items"
    :slide="NewsCardRelated"
    :class="{ black, reducedBottomPadding }"
  >
    <slot />
  </SliderSection>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    &.black {
      background-color: $black;
    }

    &.reducedBottomPadding {
      padding-bottom: px(32);
    }
  }
</style>
